import React from 'react'
import Video from "../../../assets/images/video-1.jpg"
import Icon8 from "../../../assets/images/icon-8.png"
import Icon9 from "../../../assets/images/icon-9.png"
import Icon10 from "../../../assets/images/icon-10.png"
import Icon3 from "../../../assets/images/icon-3-corrected.png"
import Shape20 from "../../../assets/images/shape-20.png"
import Shape21 from "../../../assets/images/shape-21.png"
import Shape19 from "../../../assets/images/shape-19.png"
import { config } from '../config'

const Process = () => {
    return (
        <div>
            <section className="process-section">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-6 col-md-12 col-sm-12 left-column">
                            <div className="inner-box">
                                <div className="shape" style={{backgroundImage: `url(${Shape19})`}}></div>
                                <div className="sec-title">
                                    <h2>Start Your Journey to Mastery </h2>
                                    <p>Take the first step toward achieving your goals with our expert-led training. Our structured approach ensures you gain the skills and confidence needed to excel.</p>
                                </div>
                                <div className="image-box">
                                    <figure className="image"><img src={Video} alt="Journey to Mastery Image" /></figure>
                                    <div className="video-btn">
                                        <a href="https://www.youtube.com/watch?v=nfP5N9Yc72A&amp;t=28s" className="lightbox-image" data-caption=""><i className="flaticon-play-button-1"></i></a>
                                    </div>
                                </div>
                                <div className="single-item">
                                    <div className="icon"><img src={Icon8} alt="Card Icon" /></div>
                                    <h3>Get Your First <br />Free Online Lesson Today!</h3>
                                    <p>Schedule your class at your convenience.<a href={`${config.appUrl}book-a-lesson`}><i className="flaticon-right-arrow-1"></i>Schedule Now</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 right-column">
                            <div className="inner-box">
                                <div className="single-item">
                                    <div className="arrow-shape" style={{backgroundImage: `url(${Shape20})`}}></div>
                                    <span className="count-text">01</span>
                                    <div className="icon"><img src={Icon9}alt="Card Icon" /></div>
                                    <h4><a href="#">Consultation</a></h4>
                                    <p>We begin with a personalised consultation to understand your goals and learning preferences. Our experts guide you through the best options tailored to your needs. </p>
                                </div>
                                <div className="single-item">
                                    <div className="arrow-shape-2" style={{backgroundImage: `url(${Shape21})`}}></div>
                                    <span className="count-text">02</span>
                                    <div className="icon"><img src={Icon10} alt="Card Icon" /></div>
                                    <h4><a href="#">Choose Your Course</a></h4>
                                    <p>Select the perfect course that aligns with your aspirations. Whether you're starting fresh or advancing your skills, we have the right training for you.  </p>
                                </div>
                                <div className="single-item">
                                    <div className="arrow-shape" style={{backgroundImage: `url(${Shape20})`}}></div>
                                    <span className="count-text">03</span>
                                    <div className="icon"><img src={Icon3} alt="Card Icon" /></div>
                                    <h4><a href="#">Start Your Training</a></h4>
                                    <p>Begin your journey with engaging, hands-on lessons designed to help you succeed. Our structured approach ensures a smooth and effective learning experience. </p>
                                </div>
                                <div className="btn-box">
                                    <a href={`${config.appUrl}contact-us`} className="theme-btn btn-two">Send Request</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Process
